(function () {
  var buttons = Array.prototype.slice.call(document.querySelectorAll('.concierge-apply-included__item-toggle'));

  function closePanel(button, panel) {
    if (!panel) return;
    button.setAttribute('aria-expanded', 'false');
    if (panel.style.maxHeight === 'none') {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.getBoundingClientRect();
    }
    panel.style.maxHeight = '0px';
    panel.addEventListener('transitionend', function onClose(event) {
      if (event.target !== panel || event.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onClose);
      if (button.getAttribute('aria-expanded') === 'false') panel.hidden = true;
    });
  }

  function openPanel(button, panel) {
    if (!panel) return;
    button.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.addEventListener('transitionend', function onOpen(event) {
      if (event.target !== panel || event.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onOpen);
      if (button.getAttribute('aria-expanded') === 'true') panel.style.maxHeight = 'none';
    });
  }

  buttons.forEach(function (button) {
    if (button.__conciergeApplyIncludedInit) return;
    button.__conciergeApplyIncludedInit = true;
    var panel = button.nextElementSibling;
    if (panel && button.getAttribute('aria-expanded') !== 'true') {
      panel.hidden = true;
      panel.style.maxHeight = '0px';
    }
    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      buttons.forEach(function (otherButton) {
        if (otherButton === button) return;
        closePanel(otherButton, otherButton.nextElementSibling);
      });
      if (expanded) {
        closePanel(button, panel);
      } else {
        openPanel(button, panel);
      }
    });
  });
})();
